module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Light.ttf?v=1c0ea878e037e72cd488f3853edaf2ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Light.ttf
// module id = 654
// module chunks = 0